<template>
  <div id="menu">
    <div class="holeTitle">
      <img
        :src="menuRoot.icon"
        :onerror="placeHoldImg"
        :style="{width: '44px', height: '44px'}"
      />
      <span class="logo_text" :style="{'margin-left': '25px'}">{{
        menuRoot.name
      }}</span>
    </div>
    <Menu
      :theme="theme2"
      :open-names="[submenuOpen]"
      :active-name="menuActive"
      accordion
      class="w-auto"
      @on-select="changeMenu"
    >
      <Submenu
        :name="menuList[index].title"
        v-for="(item, index) in menuList"
        :key="index"
      >
        <template slot="title">
          <div
            class="verticalItem d-flex align-items-center"
            :style="{'line-height': 'baseline'}"
          >
            <img
              :src="item.icon"
              :onerror="placeHoldImg"
              :style="{width: '16px', height: '16px'}"
            />
            <span class="layout-text" :style="{'margin-left': '10px'}">{{
              itemTitle(item)
            }}</span>
          </div>
        </template>

        <template v-for="(child, index2) in item.children">
          <MenuItem
            :name="child.path"
            :to="child.path"
            :key="'menuitem' + index2 + child.path"
          >
            <div
              class="verticalItem d-flex align-items-center"
              :style="{'line-height': 'baseline'}"
            >
              <img
                :src="child.icon"
                :onerror="placeHoldImg"
                :style="{width: '14px', height: '14px'}"
              />
              <span
                class="layout-text"
                :key="'title' + child.path"
                :style="{'margin-left': '10px'}"
              >
                {{ itemTitle(child) }}
              </span>
            </div>
            <!-- <Icon :type="child.icon" :key="'icon' + index2 + child.path"></Icon> -->
          </MenuItem>
        </template>
      </Submenu>
    </Menu>
  </div>
</template>
<script>
export default {
  name: 'YnMenu',
  data() {
    return {
      theme2: 'dark',
      menuActive: '',
      submenuOpen: '',
    };
  },
  props: {
    menuList: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
    menuRoot: {
      type: Object,
      default() {
        return {};
      },
    },
    currentPaths: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
    placeHoldImg: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
    menuitemClasses: function() {
      return ['menu-item', this.isCollapsed ? 'collapsed-menu' : ''];
    },

    // currentPaths() {
    //   return this.currentPaths[this.currentPaths.length - 1];
    // },
  },
  created() {
    this.menuActive = this.currentPaths[2].path;
    this.submenuOpen = this.currentPaths[1].title;
  },
  methods: {
    itemTitle(item) {
      if (typeof item.title === 'object') {
        return this.$t(item.title.i18n);
      } else {
        return item.title;
      }
    },
    changeMenu(path) {
      this.$emit('menuClick', path);
    },

    itemTitle(item) {
      if (typeof item.title === 'object') {
        return this.$t(item.title.i18n);
      } else {
        return item.title;
      }
    },
  },
};
</script>
<style lang="less" scoped>
#menu {
  img {
    border-radius: 3px;
  }
  .holeTitle {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 60px;
    line-height: 60px;
    padding-left: 30px;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    background: #fff;
  }
  .ivu-menu-submenu-title {
    .layout-text {
      font-size: 16px;
    }
  }
}

// 目录折叠
.ivu-layout-sider-collapsed {
  .holeTitle {
    .logo_text {
      display: none;
      transition: width 0.2s ease;
    }
  }
  .layout-text {
    display: inline-block;
    transition: width 0.2s ease;
  }
  .ivu-menu-vertical {
    .ivu-menu-submenu-title {
      padding: 14px 16px;
      position: relative;
      cursor: pointer;
      z-index: 1;
      transition: all 0.2s ease-in-out;
    }
  }
  .ivu-menu-submenu-title {
    display: none !important;
  }
  .ivu-menu-item {
    padding: 14px 24px;
  }
  .btn_tools {
    .ivu-btn {
      margin: 0 5px;
    }
  }
}
</style>
